import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { IndexDBImplementation } from '@commoncore/implementation/IndexDBImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { PrivateFolderImplementation } from '@mainrepo/app/core/implementation/PrivateFolderImplementation';
import { TwoFactorImplementation } from '@mainrepo/app/core/implementation/twoFactorImplementation';
import { Controller } from './Controller';

export class PrivateFolderController extends Controller{
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
    pfImpl: any;
    twoFactorImplementation:any;
    localStorageSvc:any;
    listService: any;
    cacheImpl:IndexDBImplementation;
    cleverTapEventsService:any;
    fileOperationsImplementation: FileOperationsImplementation;


    public constructor(public globalService:GlobalService) {
      super(globalService)
      this.pfImpl =  PrivateFolderImplementation.getInstance(this.globalService);
      this.twoFactorImplementation = TwoFactorImplementation.getInstance(this.globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
      this.cacheImpl = IndexDBImplementation.getInstance(globalService);

    }
    
    public static getInstance(globalService):PrivateFolderController{
      if(this.singleInstance == null){
        this.singleInstance = new PrivateFolderController(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
	  }


    public setEnvObjects(globalService){
        this.universalService = globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.localStorageSvc = globalService.getLocalStorageSvcRef();
        this.listService = globalService.getListServiceRef();
        this.cleverTapEventsService = globalService.getCleverTapEventsvc();
        
    }

    async unlockPF(password){
      var serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["privateFolderPasswordValidation"];
      try{
        let result = await this.pfImpl.validatePrivateFolderAceess(serviceUrl,password);
        return result;
      }catch(exc){
        console.log("exception validating PPF password",exc);
        return exc;
      }
    }

    async setupPrivateFolderWithPassphrase() {
      await this.pfImpl.enablePrivateFolder()
    }

    openFolder(folder) {
      var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
      collapsedHeight = collapsedHeight?collapsedHeight:0
      const result = this.pfImpl.openFolder(folder);
    }

    async updateUIAfterPerformingAction(list,executedTask){
      var array = []
      if(this.universalService.nameSort){
        array = this.universalService.sortByNameArray
      }else{
        array = this.universalService.sortByDateArray
      }
      if(executedTask == 'TRASH' || executedTask == "MOVE"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          if(executedTask == "MOVE"){
            this.cacheImpl.clearStores("FOLDERS");
            this.cacheImpl.clearStores("ALL_FILES");
          }
          if( this.universalService.currentTab == 'PrivateFolder' || executedTask == 'TRASH'){
            if(executedTask == 'TRASH'){
              this.cleverTapEventsService.pfDeleteObj();
            }
            var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
            array = result
          }
          if(this.universalService.virtualGridEnabled){
            AppEvents.virtualDOMObservable.next({"updateVDOM":true,"removeObjects":true,objectsList:list})
          }
      }else if(executedTask == 'RENAME'){
          this.fileOperationsImplementation.setHandler(this.globalService);
          var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
          array = result
          if(this.universalService.virtualGridEnabled){
            let updatedList = this.fileOperationsImplementation.returnTheListOfUpdatedObjectsForVirtualGrid(list,array);
            AppEvents.virtualDOMObservable.next({"updateVDOM":true,"updateObjects":true,objectsList:updatedList})
          }
      }else{
        
      }

      
      if(array.length == 0){
        return "empty"
      }else{
        return ""
      }
  }

  async disablePrivateFolder() {
    const serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["privateFolderDisable"];
      try{
        let result =  await this.pfImpl.disablePrivateFolder(serviceUrl,this.localStorageSvc.getPrivateFolderPassword());
        if(result != undefined) {
          return result;
        }
      }catch(exc){
        console.log("exception disabling PPF password",exc);
        return exc;
      }
  }
}